(function () {
  const modal = document.getElementById("ec-lgpd-modal");
  const overlay = document.getElementById("ec-lgpd-overlay");
  const acceptButton = document.getElementById("ec-lgpd-accept");

  if (!modal || !overlay) return;

  if (modal.dataset.ecLgpdInitialized === "true") return;
  modal.dataset.ecLgpdInitialized = "true";

  const MAX_Z_INDEX = parseInt(modal.dataset.zIndex || "2147483647", 10);
  const CONSENT_KEY = "ec-lgpd-consent";

  function safeGetConsent() {
    try {
      return localStorage.getItem(CONSENT_KEY) === "accepted";
    } catch (e) {
      console.error("Error getting consent:", e);
      return false;
    }
  }

  function safeSetConsent() {
    try {
      localStorage.setItem(CONSENT_KEY, "accepted");
    } catch (e) {
      console.error("Error setting consent:", e);
    }
  }

  function moveToEndOfBody() {
    document.body.appendChild(overlay);
    document.body.appendChild(modal);
    overlay.style.zIndex = String(MAX_Z_INDEX);
    modal.style.zIndex = String(MAX_Z_INDEX);
  }

  function showModal() {
    moveToEndOfBody();
    modal.classList.add("active");
    overlay.classList.add("active");
  }

  function hideModal() {
    modal.classList.remove("active");
    overlay.classList.remove("active");
  }

  function checkCookieConsent() {
    if (!safeGetConsent()) {
      setTimeout(showModal, 1000);
    }
  }

  if (acceptButton && acceptButton.dataset.ecLgpdBound !== "true") {
    acceptButton.dataset.ecLgpdBound = "true";
    acceptButton.addEventListener("click", function () {
      safeSetConsent();
      hideModal();
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", checkCookieConsent);
  } else {
    checkCookieConsent();
  }
})();
